<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">My Wishlist</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container ib-p-0 article-box">
        <div class="row" v-if="wishlistProducts.length > 0">
          <div v-for="(product, index) in wishlistProducts" :key="'filteredproducts' + index" class="col-lg-6 col-xl-3">
            <div class="ib-card">
              <div class="d-flex align-items-center mb-3">
                <div class="ib-card-logo">
                  <img class="img-fluid" :src="product.company_logo">
                </div>
                <div class="in-flex-1">
                  <div class="ib-card-title">{{product.company_name}}</div>
                </div>
              </div>
              <div class="d-flex align-items-baseline">
                <div style="width:100%;">
                  <div class="ib-card-subtitle">{{product.product_name}}</div>

                  <div class="ib-card-plan" style="width: max-content !important;" v-if="product.plan_name != ''">{{product.plan_name}}</div>
                </div>
              </div>

              <div class="d-flex justify-content-center" style="position: absolute; bottom: 38px; left: 87px;">
                <div class="pr-1">
                  <button class="ib-btn-primary ib-btn-hover" @click="buyProduct(product)">Buy&nbsp;Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12 text-center">
            <h2 class="in-empty-note">No Item in Wishlist</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading';

  export default {
    name: 'Wishlist',
    data() {
      return {
        showLoader: false,
        wishlistProducts: {}
      }
    },
    components: {
      loading
    },
    created() {
      const self = this;
      self.getWishlistData();
    },
    methods: {
      async getWishlistData() {
        const self = this;

        self.showLoader = true;
        await axios.get('plan_wishlist').then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            self.wishlistProducts = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        })
      },
      buyProduct(product) {
        const self = this;
        self.$router.push({ name: 'Acquisition', params: { classId: product.mainclass_id }, query : { redirectFor :'recentSearch', productId: product.id} });
      }
    }
  }
</script>
<style scoped>
/* .ib-card{
  min-height: 240px !important;
} */
.ib-card .ib-btn-primary {
    padding: 9px 18px !important;
    position: relative;
    top: 20px;
}
@media (max-width:992px) {
  .ib-card {
    width: 90% !important;
    margin:0 auto 1.25rem !important;
  }
}
@media(max-width:550px){
  .in-empty-note {
    font-size: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wishlist/Index.vue